export default __webpack_public_path__ + "static/media/photo--lg--blitz-2.8add8b9c.jpg";